import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * ChartMindFooter — autosave status only.
 *
 * Back / Next / Skip live under the stepper tabs in ChartMindStepNav. This bar stays
 * sticky at the bottom so save state remains visible while scrolling long steps.
 */
const ChartMindFooter = ({
  saving,
  lastSavedAt,
  hasUnsavedChanges = false,
  // [BETA-KIJABE] When true, hides the autosave status indicator. Remove when beta ends.
  disableSave = false,
}) => {
  const formatSavedTime = (date) => {
    if (!date) return null;
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  if (disableSave) return null;

  const saveStatus = saving ? (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <CircularProgress size={14} thickness={5} />
      <Typography variant="caption" color="text.secondary">
        Saving...
      </Typography>
    </Box>
  ) : hasUnsavedChanges ? (
    <Typography variant="caption" color="text.secondary">
      Unsaved changes
    </Typography>
  ) : lastSavedAt ? (
    <Typography variant="caption" color="text.secondary">
      Saved at {formatSavedTime(lastSavedAt)}
    </Typography>
  ) : null;

  if (!saveStatus) return null;

  return (
    <Box
      data-testid="chartmind-save-footer"
      sx={{
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "background.default",
        px: 2,
        py: 1,
        zIndex: 10,
        flexShrink: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {saveStatus}
    </Box>
  );
};

export default ChartMindFooter;
